import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Wordmark } from "@/components/Logo";

const NAV = [
  { to: "/", label: "Accueil" },
  { to: "/studio", label: "Le Studio" },
  { to: "/academie", label: "L'Académie" },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  const linkClass = ({ isActive }) =>
    `relative text-sm tracking-[0.14em] uppercase transition-colors duration-300 after:absolute after:left-0 after:-bottom-1 after:h-px after:bg-foreground after:transition-all after:duration-300 ${
      isActive ? "after:w-full" : "after:w-0 hover:after:w-full"
    }`;

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-background/85 border-b border-border/60">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-home-link" className="text-2xl" aria-label="Maison Ria — accueil">
          <Wordmark />
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`nav-${item.label.toLowerCase().replace(/[^a-z]/g, "")}-link`}
              className={linkClass}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3 md:gap-5">
          <button
            data-testid="nav-reserver-btn"
            onClick={() => navigate("/studio#reservation")}
            className="hidden md:inline-block bg-primary text-primary-foreground text-sm tracking-[0.12em] uppercase px-6 py-3 transition-colors duration-300 hover:bg-foreground"
          >
            Réserver
          </button>
          <button
            data-testid="mobile-menu-btn"
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden p-2"
            aria-label="Menu"
          >
            {mobileOpen ? <X size={24} strokeWidth={1.25} /> : <Menu size={24} strokeWidth={1.25} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-background border-t border-border/60 px-6 py-8 flex flex-col gap-6">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              onClick={() => setMobileOpen(false)}
              className="font-display text-2xl"
            >
              {item.label}
            </NavLink>
          ))}
          <button
            data-testid="mobile-reserver-btn"
            onClick={() => {
              setMobileOpen(false);
              navigate("/studio#reservation");
            }}
            className="mt-2 bg-primary text-primary-foreground text-sm tracking-[0.12em] uppercase px-6 py-4 w-max"
          >
            Réserver au studio
          </button>
        </div>
      )}
    </header>
  );
}
